import React from 'react';
import { Icon, Message } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const RequestWorkspaceMessage = () => (
  <Message warning>
    <Icon name="info" />
    <FormattedMessage id="request.new.workspace.wizard.info" />
  </Message>
);

export default RequestWorkspaceMessage;
